import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { checkoutApi } from 'Utils/api';
import {
  createOrderRequest,
  createOrderSuccess,
  createOrderFailure,
} from 'Redux/Slices/CheckoutSlice';
import { clearCart } from 'Redux/Slices/CartSlice';

export const createOrderEpic = (action$: any) =>
  action$.pipe(
    ofType(createOrderRequest.type),
    mergeMap((action: any) =>
      from(checkoutApi.createOrder(action.payload)).pipe(
        mergeMap((response) => of(
          createOrderSuccess(response.data.order),
          clearCart()
        )),
        catchError((error) =>
          of(createOrderFailure(error.response?.data?.error || 'Failed to create order'))
        )
      )
    )
  );
